export async function createGrid(...parameters) {

  const { createGrid: createGridWrapper } = await import('ag-grid-wrapper');

  return createGridWrapper(...parameters);

}